// 认证相关API
import httpClient from '../http'
import { API_ENDPOINTS } from '../config'

export const authApi = {
  // 管理员登录
  adminLogin: data => httpClient.post(API_ENDPOINTS.AUTH.ADMIN_LOGIN, data),

  // 代理登录
  agentLogin: data => httpClient.post(API_ENDPOINTS.AUTH.AGENT_LOGIN, data),

  // 用户登录
  userLogin: data => httpClient.post(API_ENDPOINTS.AUTH.USER_LOGIN, data),

  // 邀请注册
  inviteRegister: data => httpClient.post(API_ENDPOINTS.AUTH.INVITE_REGISTER, data),

  // 获取用户信息
  getUserInfo: () => httpClient.get(API_ENDPOINTS.AUTH.USER_INFO),

  // 登出
  logout: () => httpClient.post(API_ENDPOINTS.AUTH.LOGOUT)
}
